import React from 'react';
import {useTranslation} from 'react-i18next';
import {TranslatedText} from '../../../../../../helpers/helpers';
import BackgroundImage from './BackgroungImage';
import './Sidebar.scss';

const Sidebar = ({type}) => {
  const {t} = useTranslation();

  return (
    <div className="Sidebar" data-testid="Sidebar">

      <BackgroundImage/>
      <div className="content">
        <div className="container">
          <div className="text-container">
            <div className="headline-bold-fs4"><TranslatedText i18nKey="cases.analisi_acqua.pre_step_form.request"/></div>
            <span className="button headline-bold-fs2">{t(`cases.analisi_acqua.pre_step_form.control.${type}`)}</span>
          </div>
        </div>
      </div>
    </div>
  )
};

export default Sidebar;
